import React from 'react'
import { array, object } from 'prop-types'
import { NavDropdown, MenuItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const CampaignChooser = ({
  campaigns, campaign
}) => (
  <ul className='nav navbar-nav'>
    <NavDropdown title={(campaign && campaign.name) || 'Selecione uma campanha '} id='basic-nav-dropdown'>
      {campaigns.map((campaign) => {
        return (
          <LinkContainer key={campaign.id} to={`/campaigns/${campaign.id}/videos`}>
            <MenuItem>{campaign.name}</MenuItem>
          </LinkContainer>
        )
      })}
      {/*<MenuItem divider />
      <LinkContainer to='/campaigns/add'>
        <MenuItem>Criar nova campanha</MenuItem>
      </LinkContainer>*/}
    </NavDropdown>
  </ul>
)

CampaignChooser.propTypes = {
  campaigns: array,
  campaign: object
}

export default CampaignChooser



// WEBPACK FOOTER //
// ./src/components/CampaignChooser.js